import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {RoadtripDetailsPage} from './roadtrip-details.page';
import {UnrRoadtripStepsComponent} from './route-steps/roadtrip-steps.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule
  ],
  declarations: [
    UnrRoadtripStepsComponent,
    RoadtripDetailsPage
  ],
  exports: [
    UnrRoadtripStepsComponent
  ]
})
export class RoadtripDetailsPageModule {
}
